import React from 'react';

const Footer = () => {
    return (
        <footer style={{marginTop: '1rem'}} className="bg-dark">
            <div className="container center-xs">
                <div className="flex text-light">
                    <div>
                        <p>Emagine Exp Corporation &copy; The Emagine Experience Copyright 2020</p>
                    </div>
                    <div>
                        <p><span><a className="text-light" href="https://emaginetalks.com/privacy-policy.html">Privacy Policy</a></span> | <span><a className="text-light" href="https://emaginetalks.com/terms-and-conditions.html">Terms and Conditions</a></span></p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
